import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { forwardRef } from 'react';
import styled, { css } from '@xstyled/styled-components';
import { system } from '@trybeapp/ui.system';
import 'prop-types';

var _excluded = ["as", "children", "dataTestId", "lines", "variant"];
var _templateObject, _templateObject2;
var TAG_NAMES = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  body1: 'p',
  body2: 'p',
  body3: 'p',
  body4: 'p',
  subtitle1: 'p',
  subtitle2: 'p',
  meta1: 'p',
  meta2: 'p'
};
var getBlockHeight = function getBlockHeight(lines) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  display: -webkit-box;\n  /* stylelint-disable-next-line property-no-vendor-prefix */\n  -webkit-box-orient: vertical;\n  /* stylelint-disable-next-line property-no-vendor-prefix */\n  -webkit-line-clamp: ", ";\n  overflow: hidden;\n"])), lines || 'none');
};
var StyledText = /*#__PURE__*/styled.p(function (_ref) {
  var lines = _ref.lines,
    theme = _ref.theme,
    underline = _ref.underline,
    variant = _ref.variant;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n\n    /* Start fallback for non-webkit */\n    display: block;\n    ", ";\n    /* End fallback for non-webkit */\n\n    ", "\n  "])), theme.texts[variant], underline && theme.underline, lines && lines !== Infinity && getBlockHeight(lines), system);
});
var Text = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var as = _ref2.as,
    children = _ref2.children,
    dataTestId = _ref2.dataTestId,
    lines = _ref2.lines,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'body1' : _ref2$variant,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var tagName = as || TAG_NAMES[variant];
  return /*#__PURE__*/React.createElement(StyledText, _extends({
    as: tagName,
    "data-testid": dataTestId,
    lines: lines,
    ref: ref,
    variant: variant
  }, rest), children);
});
Text.displayName = 'Text';

export { Text };
